import { render, staticRenderFns } from "./Bot.vue?vue&type=template&id=9d84d6d8&"
import script from "./Bot.vue?vue&type=script&lang=js&"
export * from "./Bot.vue?vue&type=script&lang=js&"
import style0 from "./Bot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports